import React from 'react';
import { Provider } from 'react-redux';

import App from './App';
import reduxStore from './redux';
import reportWebVitals from './reportWebVitals';
import './index.scss';

import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { logger } from './utils/logger';
import { FeatureReaderProvider } from '@farmart-engineering/brave-ship-react';
import { ImagePreviewProvider } from './component/image-preview-v2/imagePreview.context';
import ENVIRONMENT from './config/environment';

import { AbilityProvider } from '@/context/Access';
import { AccessControlProvider } from './accessControl/AccessControlContext';

const queryClient = new QueryClient({
	// Will provide defaults here After Discussing with Team !!IMPORTANT
	// defaultOptions: {
	//   queries: {
	//     refetchOnWindowFocus: false,
	//     retry: false,
	//     staleTime: 60000,
	//   }
	// }
});

const container = document.getElementById('root');

logger.initialize();

const environment = import.meta.env.VITE_ENVIRONMENT;

const workspaceEnvSuffix =
	environment === 'production'
		? ''
		: environment === 'stage'
			? '-staging'
			: `-${environment}`;

if (container) {
	const root = createRoot(container);
	root.render(
		<React.StrictMode>
			<QueryClientProvider client={queryClient}>
				<Provider store={reduxStore}>
					<AbilityProvider>
						<ImagePreviewProvider>
							<FeatureReaderProvider
								connection={'WS'}
								autoLoadFeatureFlags={false}
								featureReaderConfig={{
									firebase: {
										apiKey: ENVIRONMENT.FIREBASE_API_KEY,
										authDomain: ENVIRONMENT.FIREBASE_AUTH_DOMAIN,
										databaseURL: ENVIRONMENT.FIREBASE_DATABASE_URL,
										projectId: ENVIRONMENT.FIREBASE_PROJECT_ID,
										storageBucket: ENVIRONMENT.FIREBASE_STORAGE_BUCKET,
										messagingSenderId: ENVIRONMENT.FIREBASE_MESSAGING_SENDER_ID,
										appId: ENVIRONMENT.FIREBASE_APP_ID,
										measurementId: ENVIRONMENT.FIREBASE_MEASUREMENT_ID,
									},
									workspace: `fmt-os${workspaceEnvSuffix}`,
								}}
							>
								<AccessControlProvider>
									<App />
								</AccessControlProvider>
							</FeatureReaderProvider>
						</ImagePreviewProvider>
					</AbilityProvider>
				</Provider>
			</QueryClientProvider>
		</React.StrictMode>,
	);
	reportWebVitals();
}
